import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../_services/profiles.service';
import { Profile } from '../_models/profile.model';

@Component({
  selector: 'app-tramite-empresa',
  templateUrl: './tramite-empresa.component.html',
  styleUrls: ['./tramite-empresa.component.scss'],
})
export class TramiteEmpresaComponent implements OnInit {
  linkTitle: string = '';
  public isCollapsed = false;
  isOpen = true;
  constructor(private profileService: ProfileService) {}

  ngOnInit() {
    this.profileService
      .getProfileByCode('IEMP')
      .subscribe((profile: Profile) => {
        const ifr: HTMLIFrameElement = document.createElement('iframe');
        ifr.setAttribute('id', 'embeeded-frame');
        ifr.setAttribute('frameborder', '0');
        document.getElementById('iframe-goes-here').appendChild(ifr);
        if (profile.procedures.length > 0) {
          if (profile.procedures[0].proc_url) {
            ifr.contentWindow.location.replace(profile.procedures[0].proc_url);
          }
          this.linkTitle = profile.procedures[0].proc_name;
        }
      });
  }
}
